var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeclineHistoryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "27 27 104 105",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer5"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "currentColor",
    strokeWidth: 2.33364773,
    fillOpacity: 1,
    id: "path5116",
    cx: 78.960365,
    cy: 78.805931,
    rx: 51.804562,
    ry: 51.726658
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "error"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_03-info",
    transform: "translate(26.000000, 26.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fill: "currentColor",
    d: "M53,1C24.3,1,1,24.3,1,53s23.3,52,52,52s52-23.3,52-52S81.7,1,53,1z M53,101    C26.5,101,5,79.5,5,53S26.5,5,53,5s48,21.5,48,48S79.5,101,53,101z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x30_01-error",
    transform: "translate(31.000000, 32.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fill: "#ffffff",
    d: "M41.4,1.6c-0.8-0.8-2-0.8-2.8,0L22,18.2L5.4,1.6c-0.8-0.8-2-0.8-2.8,0s-0.8,2,0,2.8L19.2,21     L2.6,37.6c-0.8,0.8-0.8,2,0,2.8C3,40.8,3.5,41,4,41s1-0.2,1.4-0.6L22,23.8l16.6,16.6C39,40.8,39.5,41,40,41s1-0.2,1.4-0.6     c0.8-0.8,0.8-2,0-2.8L24.8,21L41.4,4.4C42.2,3.6,42.2,2.4,41.4,1.6z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeclineHistoryIcon);
export default __webpack_public_path__ + "static/media/DeclineHistoryIcon.28d9403a326fdbd0a15d4837e59b0535.svg";
export { ForwardRef as ReactComponent };